<template>
	<div class="childDiv1" id="page5" ref="mainEl" page="5">
		<div class="childWrapper relative">
			<div class="w-full h-full" ref="wrapEl">
				<!-- before zoom -->
				<div ref="part1El" class="w-full h-full absolute top-0 left-0 origin-[65%_30%] will-change-transform">
					<img alt="" src="images/1x_images/section1/page5/page5-text.png" srcset="images/2x_images/section1/page5/page5-text.png 2x" class="absolute top-[300px] left-[70px] z-[3]" />
					<img alt="" src="images/1x_images/section1/page5/btn-zoomin.png" srcset="images/2x_images/section1/page5/btn-zoomin.png 2x" class="button absolute top-[410px] left-[280px] z-[3]" @click="zoom()" />

					<div ref="bigCellEl" class="absolute z-[2]">
						<img alt="" src="images/1x_images/section1/page5/page5-label.png" srcset="images/2x_images/section1/page5/page5-label.png 2x" class="absolute top-[280px] left-[680px] z-[3]" />
						<Cell :pWidth="600" class="absolute top-[325px] left-[335px] rotate-[0deg]" />
					</div>

					<Cell2 :pWidth="280" class="absolute z-[1] top-[700px] left-[170px] rotate-[60deg]" ref="smallCellEl_2" />
					<Cell2 :pWidth="400" class="absolute z-[1] top-[680px] left-[660px] rotate-[100deg]" ref="smallCellEl_3" />
				</div>

				<!-- after zoom -->
				<div ref="part2El" class="w-full h-full absolute top-0 left-0 origin-[65%_30%] will-change-transform">
					<img alt="" src="images/1x_images/section1/page5/page5-text2.png" srcset="images/2x_images/section1/page5/page5-text2.png 2x" class="absolute top-[150px] left-[120px] z-[3]" />
					<img alt="" src="images/1x_images/section1/page5/page5-btn.png" srcset="images/2x_images/section1/page5/page5-btn.png 2x" class="button absolute top-[415px] left-[110px] z-[3]" @click="createParticle()" />

					<div class="relative w-full h-full" ref="skinContainerEl">
						<div ref="pointerEl" class="relative z-[4]">
							<div class="absolute top-[438px] left-[370px] z-[2]">
								<img alt="" src="images/1x_images/section1/page5/page5-cell.png" srcset="images/2x_images/section1/page5/page5-cell.png 2x" />
								<img alt="" src="images/1x_images/section1/page5/page5-cell-pointer.png" srcset="images/2x_images/section1/page5/page5-cell-pointer.png 2x" class="absolute top-0" />
								<img alt="" src="images/1x_images/section1/page5/page5-cell-protein.png" srcset="images/2x_images/section1/page5/page5-cell-protein.png 2x" class="absolute top-[-10px] origin-[42%_44%]" ref="cellEl" />
							</div>

							<div ref="particleContainerEl" class="absolute w-[240px] h-[290px] top-[565px] left-[470px] z-[1]">
								<img
									v-for="x in particles"
									:key="x.id"
									alt=""
									class="absolute center top-[130px]"
									src="images/ball-small-black.png"
									srcset="images/ball-small-black.png 2x"
									:ref="`particle${x.id}El`"
									:id="`particle${x.id}El`"
									:style="{ width: x.width + 'px' }" />
							</div>
						</div>

						<div class="absolute bottom-[-90px] left-0 z-[2]">
							<div class="w-full h-fit" ref="skinEl">
								<img alt="" src="images/1x_images/section1/page5/page5-skin-top.png" srcset="images/2x_images/section1/page5/page5-skin-top.png 2x" class="absolute top-[12px] left-0 z-[6] will-change-transform" ref="skinTopEl" />
								<img alt="" src="images/1x_images/section1/page5/page5-skin-btm.png" srcset="images/2x_images/section1/page5/page5-skin-btm.png 2x" class="absolute bottom-[48px] left-0 z-[5] will-change-transform" ref="skinBtmEl" />
								<img alt="" src="images/1x_images/section1/page5/page5-skin2.png" srcset="images/2x_images/section1/page5/page5-skin2.png 2x" class="relative bottom-0 left-0 z-[3] will-change-transform" ref="skinBgEl" />
								<img alt="" src="images/1x_images/section1/page5/page5-skin3.png" srcset="images/2x_images/section1/page5/page5-skin3.png 2x" class="absolute bottom-[68px] left-0 z-[4] will-change-transform opacity-0" ref="skinBg2El" />
								<img alt="" src="images/1x_images/section1/page5/page5-label2.png" srcset="images/2x_images/section1/page5/page5-label2.png 2x" class="absolute top-[87px] left-[55px] z-[7]" ref="skinLabelEl" />
							</div>
						</div>

						<div class="absolute center z-[3] w-fit top-[1040px]" ref="btnBtmEl">
							<img alt="" src="images/1x_images/section1/page5/page5-bar.png" srcset="images/2x_images/section1/page5/page5-bar.png 2x" class="" />
							<div class="flex absolute bottom-[20px] w-[500px] justify-evenly center">
								<div @click="activate(1)" class="button rounded-full w-[50px] aspect-square border-[1px] border-[#c2ad6c] font-thin italic text-[25px] flex justify-center items-center" :style="{ backgroundColor: active == 1 ? '#c2ad6c' : '' }">
									20s
								</div>
								<div @click="activate(2)" class="button rounded-full w-[50px] aspect-square border-[1px] border-[#c2ad6c] font-thin italic text-[25px] flex justify-center items-center" :style="{ backgroundColor: active == 2 ? '#c2ad6c' : '' }">
									30s
								</div>
								<div @click="activate(3)" class="button rounded-full w-[50px] aspect-square border-[1px] border-[#c2ad6c] font-thin italic text-[25px] flex justify-center items-center" :style="{ backgroundColor: active == 3 ? '#c2ad6c' : '' }">
									40s
								</div>
								<div @click="activate(4)" class="button rounded-full w-[50px] aspect-square border-[1px] border-[#c2ad6c] font-thin italic text-[25px] flex justify-center items-center" :style="{ backgroundColor: active == 4 ? '#c2ad6c' : '' }">
									50s
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import Cell from "../../components/BubbleDraw1.vue";
import Cell2 from "../../components/BubbleDraw2.vue";
import Particles from "../../components/Particles.vue";
gsap.registerPlugin(MotionPathPlugin);

export default {
	name: "page-1",
	components: { Cell, Cell2, Particles },
	data() {
		return {
			animate: true, // always true, false only for testing
			stopped: true,
			tween: [],
			active: 1,
			particles: [],
			particleCount: 0,
			context: null,
			maxNum: 10,
			zoomed: false,
		};
	},
	methods: {
		start() {
			this.context.add(() => {
				this.animateCell();
			});
		},
		stop() {
			gsap.set(this.$refs.part1El, { autoAlpha: 1, scale: 1, zIndex: 2 });
			gsap.set(this.$refs.part2El, { autoAlpha: 0, scale: 0.4, zIndex: 1 });
			if (this.context) this.context.revert();
			this.particles = [];
			this.particleCount = 0;
			this.zoomed = false;
			this.activate(1, false);
		},
		animateCell() {
			var moveY = Math.floor(Math.random() * 160 - 80);
			var currentY = gsap.getProperty(this.$refs.bigCellEl, "y");
			var speed = 20;
			var duration = Math.abs(currentY - moveY) / speed;

			// prettier-ignore
			gsap.to(this.$refs.bigCellEl, { force3D: true, y: moveY, duration: duration, ease: "sine.inOut", onComplete: ()=> {
				this.animateCell();
			}});
		},
		animateCell2() {
			// prettier-ignore
			gsap.to(this.$refs.cellEl, { force3D: true, y: 15, duration: 2, ease: "sine.inOut", repeat: -1, yoyo: true});
		},
		animateCell2rotate() {
			// prettier-ignore
			gsap.to(this.$refs.cellEl, {force3D: true, rotate: "random(-7,14)", duration: "random(2,4)", ease: "sine.inOut", onComplete: ()=> {
				this.animateCell2rotate()
			}});
		},
		activate(type, animate = true) {
			this.active = type;
			const val = type - 1;
			// const distance = 10;
			gsap.to(this.$refs.pointerEl, { y: 50 * val, ease: "out", duration: animate ? 0.5 : 0, overwrite: true });
			gsap.to(this.$refs.skinEl, { y: 45 * val, ease: "out", duration: animate ? 0.5 : 0, overwrite: true });
			gsap.to(this.$refs.skinBgEl, { y: -3 * val, ease: "out", duration: animate ? 0.5 : 0, overwrite: true });
			gsap.to(this.$refs.skinBg2El, { y: -3 * val, opacity: type == 4 ? 1 : 0, ease: "out", duration: animate ? 0.5 : 0, overwrite: true });
			gsap.to(this.$refs.skinLabelEl, { y: 4.5 * val, ease: "out", duration: animate ? 0.5 : 0, overwrite: true });
			// gsap.to(this.$refs.skinBtmEl, { y: 12 * val, ease: "out", duration: animate ? 0.5 : 0, overwrite: true });
			gsap.to(this.$refs.skinTopEl, { y: 2 * val, scaleY: Math.pow(0.9, val), rotate: -0.6 * val, ease: "out", duration: animate ? 0.5 : 0, overwrite: true });
		},
		zoom() {
			this.zoomed = true;
			// gsap.to(this.$refs.part1El, { scale: 10, zIndex: 1, ease: "expo.in", force3D: true, duration: 1.5 });
			gsap.to(this.$refs.part1El, { scale: 10, zIndex: 1, ease: "out", force3D: true, duration: 1.8 });
			// gsap.to(this.$refs.part1El, { x: -550, y: 1000, ease: "none", duration: 0.5, delay: 0.5 });
			gsap.to(this.$refs.part1El, { autoAlpha: 0, duration: 0.3, ease: "none", force3D: true, delay: 0.4 });
			gsap.to(this.$refs.part2El, { autoAlpha: 1, zIndex: 2, scale: 1, duration: 0.4, ease: "none", force3D: true, delay: 0.4 });
			setTimeout(() => {
				this.context.add(() => {
					this.animateCell2();
					this.animateCell2rotate();
				});
			}, 1500);
		},
		createParticle() {
			var id = this.particleCount;
			if (id >= this.maxNum) {
				// this.particles.shift();
				this.deleteParticle(this.particles[0].id); //first in first out
			}

			const width = Math.floor(Math.random() * 18 + 15);
			this.particles.push({ id: id, width: width });
			this.particleCount++;
			this.$nextTick(() => {
				this.context.add(() => {
					this.setParticle(id);
				});
			});
		},
		setParticle(id) {
			const element = this.$refs[`particle${id}El`][0];
			// const element = document.getElementById(`particle${id}El`);
			const translateY = -270 - gsap.getProperty(this.$refs.pointerEl, "y") - gsap.getProperty(this.$refs.skinContainerEl, "y");
			gsap.set(element, { x: -280, y: translateY });
			// gsap.set(this.$refs.particleEl, { x: -144, y: -240 });
			gsap.to(element, {
				duration: 1,
				force3D: true,
				motionPath: {
					path: [
						{ x: -114, y: -210 },
						{ x: 0, y: 0 },
						{ x: 0, y: 20 },
						{ x: 0, y: 30 },
						{ x: 0, y: 40 },
					],
					curviness: 1.5,
				},
				ease: "sine.inOut",
				onComplete: (id) => {
					this.floatParticle(id);
				},
				onCompleteParams: [id],
			});
		},
		floatParticle(id) {
			const element = this.$refs[`particle${id}El`][0];
			// const element = document.getElementById(`particle${id}El`);

			if (!element) return;

			var randX = Math.random() * 240 - 120;
			var randY = Math.random() * 280 - 140;

			const previousX = gsap.getProperty(element, "x");
			const previousY = gsap.getProperty(element, "y");
			var distance = Math.hypot(randX - previousX, randY - previousY);
			var speed = 20;

			gsap.to(element, {
				x: randX,
				y: randY,
				ease: "none",
				duration: distance / speed,
				onComplete: (id) => {
					this.floatParticle(id);
				},
				onCompleteParams: [id],
			});
		},
		deleteParticle(id) {
			const element = this.$refs[`particle${id}El`][0];
			// const element = document.getElementById(`particle${id}El`);

			gsap.to(element, {
				autoAlpha: 0,
				ease: "none",
				duration: 0.3,
				onComplete: (id) => {
					const index = this.particles.findIndex((item) => item.id == id);
					this.particles.splice(index, 1);
					// this.particles.shift();
				},
				onCompleteParams: [id],
			});
		},
	},
	mounted() {
		gsap.set(this.$refs.part2El, { autoAlpha: 0, scale: 0.4 });
		this.$nextTick(() => {
			console.log("aspectratio", aspectRatio < 0.74 && aspectRatio > 0.6);
			gsap.set(this.$refs.wrapEl, { y: aspectRatio < 0.74 ? 0 : "30px" });
			if (aspectRatio > 0.64 && aspectRatio < 0.74) {
				gsap.set(this.$refs.skinContainerEl, { y: 55 });
			} else if (aspectRatio < 0.64) {
				gsap.set(this.$refs.skinContainerEl, { y: 152 });
			}

			// gsap.set(this.$refs.skinContainerEl, { y: aspectRatio < 0.74 && aspectRatio > 0.64 ? "55px" : "" });
			// gsap.set(this.$refs.skinContainerEl, { y: aspectRatio < 0.64 ? "155px" : "" });
		});

		this.context = gsap.context(() => {}, this.$el); // Scope to the component's root element

		// testing
		// gsap.set(this.$refs.part1El, { autoAlpha: 0, scale: 1 });
		// gsap.set(this.$refs.part2El, { autoAlpha: 1, scale: 1 });
		// gsap.set(".modal", { autoAlpha: 0 });
	},
};
</script>

<style scoped></style>
